import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useShop } from "@/context/ShopContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { t } = useTranslation();
  const { wishlist } = useShop();
  return (
    <section className="py-12 lg:py-16" data-testid="wishlist-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif-bm text-3xl md:text-5xl">{t("nav.wishlist")}</h1>
        {wishlist.length === 0 ? (
          <div className="text-center py-20 text-[var(--bm-muted)]">
            Your wishlist is empty. <Link to="/shop" className="underline text-[#111]">Browse the collection →</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mt-10">
            {wishlist.map((p, i)=> <ProductCard key={p.id} product={p} index={i}/>)}
          </div>
        )}
      </div>
    </section>
  );
}
